import React from 'react';
import ReactDOM from 'react-dom';
import Toast from './index';
import './style.scss';
import { UQToastProps } from './index';

export interface UQToastContainerProps {
  toasts: UQToastProps[];
  onClose: (id: string) => void;
}

const UQToastContainer: React.FC<UQToastContainerProps> = ({ toasts, onClose }) => {
  const positions = ['top-left', 'top-right', 'bottom-left', 'bottom-right'] as const;

  const container = (
    <>
      {positions.map((position) => (
        <div key={position} className={`uq-toast-container uq-toast-${position}`}>
          {toasts
            .filter((toast) => toast.position === position)
            .map((toast) => (
              <Toast key={toast.id} {...toast} onClose={onClose} />
            ))}
        </div>
      ))}
    </>
  );
  return ReactDOM.createPortal(container, document.body);
};

export default UQToastContainer;